export default "__VITE_ASSET__CQvxBzEX__"